(function organizationalUnitModuleDefinition() {
    'use strict';

    angular.module('OrganizationalUnit', ['ui.router', 'ui.tree', 'ui.treeExtend', 'Config', 'Entities', 'ErrorsExtend', 'UnitOrgControl', 'AuthExtend', 'ClickOnce', 'Actions'])
        .config([
            'configProvider', '$stateProvider','loginProvider',
            function organizationalUnitConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('organizational-unit-find', {
                    url: '/OrganizationalUnit/List',
                    templateUrl: config.resourceUrl('/views/organizational-unit/list.html'),
                    controller: 'OrganizationalUnitFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ORGANIZATIONALUNIT READ').or('ORGANIZATIONALUNIT WRITE')
                });

                $stateProvider.state('organizational-unit-add', {
                    url: '/OrganizationalUnit/Add',
                    templateUrl: config.resourceUrl('/views/organizational-unit/add-modify.html'),
                    controller: 'OrganizationalUnitAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ORGANIZATIONALUNIT WRITE')
                });

                $stateProvider.state('organizational-unit-modify', {
                    url: '/OrganizationalUnit/Modify/{id}',
                    templateUrl: config.resourceUrl('/views/organizational-unit/add-modify.html'),
                    controller: 'OrganizationalUnitModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ORGANIZATIONALUNIT WRITE')
                });

                $stateProvider.state('organizational-unit-detail', {
                    url: '/OrganizationalUnit/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/organizational-unit/detail.html'),
                    controller: 'OrganizationalUnitDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('ORGANIZATIONALUNIT READ').or('ORGANIZATIONALUNIT WRITE')
                });
            }
        ]);
})();